<template>
    <div class="page-wrapper">
        <Navbar class="style1" />
        <MainBanner />
        <Chargecalculator :loanType="1"></Chargecalculator>
        <Feature />
        <WhyChooseUs />
        <Counter />
        <Services />
        <Testimonials />
        <Footer />
    </div>
</template>

<script>
    import axios from "axios";
    import AppDownload from "../HomeOne/AppDownload";
    import Chargecalculator from "../HomeOne/Chargecalculator";
    import Counter from "../HomeOne/Counter";
    import Feature from "../HomeOne/Feature";
    import GoalSettings from "../HomeOne/GoalSettings";
    import MainBanner from "../HomeOne/MainBanner";
    import OnlineShopping from "../HomeOne/OnlineShopping";
    import Services from "../HomeOne/Services";
    import Testimonials from "../HomeOne/Testimonials";
    import WhyChooseUs from "../HomeOne/WhyChooseUs";
    import Footer from "../Layouts/Footer";
    import Navbar from "../Layouts/Navbar";

    export default {
        name: "HomeOnePage",
        components: {
            Navbar,
            MainBanner,
            Chargecalculator,
            Feature,
            WhyChooseUs,
            Counter,
            Services,
            OnlineShopping,
            Testimonials,
            AppDownload,
            GoalSettings,
            Footer,
        },
        methods: {
            async healthCheck() {
                const response = await axios.get(`https://total.aw/mdw/controller.php/customers`);
                console.log(response);
            },
        },
        mounted() {
            let ToCalculator = this.$route.params.ToCalculator;
            if (ToCalculator == true || ToCalculator == "true") scrollToSection("ChargeCalculator");
            this.healthCheck();
        },
    };
</script>
